/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApprenantRepresentantsSearch,
  FcbRepresentantApprenantsliesDtoPaginatedResults,
  FilterCriteriaInfo,
  SelectItem,
} from '../models/index';
import {
    ApprenantRepresentantsSearchFromJSON,
    ApprenantRepresentantsSearchToJSON,
    FcbRepresentantApprenantsliesDtoPaginatedResultsFromJSON,
    FcbRepresentantApprenantsliesDtoPaginatedResultsToJSON,
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    SelectItemFromJSON,
    SelectItemToJSON,
} from '../models/index';

export interface RepresentantApprenantLiesBaseSearchRequest {
    ApprenantRepresentantsSearch?: ApprenantRepresentantsSearch;
}

export interface RepresentantApprenantLiesGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface RepresentantApprenantLiesGetSelectItemsRequest {
    searchField: string;
}

/**
 * 
 */
export class RepresentantApprenantLiesApi extends runtime.BaseAPI {

    /**
     */
    async representantApprenantLiesBaseSearchRaw(requestParameters: RepresentantApprenantLiesBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbRepresentantApprenantsliesDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/RepresentantApprenantLies/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApprenantRepresentantsSearchToJSON(requestParameters.ApprenantRepresentantsSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbRepresentantApprenantsliesDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async representantApprenantLiesBaseSearch(requestParameters: RepresentantApprenantLiesBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbRepresentantApprenantsliesDtoPaginatedResults> {
        const response = await this.representantApprenantLiesBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async representantApprenantLiesGetSearchCriteriasRaw(requestParameters: RepresentantApprenantLiesGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/RepresentantApprenantLies/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async representantApprenantLiesGetSearchCriterias(requestParameters: RepresentantApprenantLiesGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.representantApprenantLiesGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async representantApprenantLiesGetSelectItemsRaw(requestParameters: RepresentantApprenantLiesGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SelectItem>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling representantApprenantLiesGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/RepresentantApprenantLies/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectItemFromJSON));
    }

    /**
     */
    async representantApprenantLiesGetSelectItems(requestParameters: RepresentantApprenantLiesGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SelectItem>> {
        const response = await this.representantApprenantLiesGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
